<template>
	<div>
		<v-container>
			<v-row>
				<v-container v-if="initialLoad">
					<v-row v-for="(item, key) in candidateSurvey.teachers" :key="key">
						<v-col cols="12">
							<v-card flat class="pa-0 ma-0" color="shade">
								<v-col cols="12" class="pb-0">
									<div :class="['text-body-1', 'pt-2', 'pb-0']">
										{{ $t('texts.teacherSurveyQuestion') + item['full_name'] + '?' }}
									</div>
								</v-col>
								<v-col cols="12" class="pb-0 pt-0">
									<v-radio-group v-model="item['teacher_rating']" row mandatory hide-details="auto">
										<v-container class="d-flex justify-space-between pt-0">
											<v-radio label="1" :value="1" class="pl-4"></v-radio>
											<v-radio label="2" :value="2"></v-radio>
											<v-radio label="3" :value="3"></v-radio>
											<v-radio label="4" :value="4"></v-radio>
											<v-radio label="5" :value="5" class="pr-4"></v-radio>
										</v-container>
									</v-radio-group>
								</v-col>
								<v-col cols="12" v-if="item['teacher_rating'] <= 3" class="pt-2 pb-8">
									<TextArea
										v-if="inEditMode"
										v-model="item['teacher_rating_explaination']"
										:label="'* ' + $t('texts.pleaseExplainRating')"
										:errorBorder="!teachersValidation[key]['full_name']"
										rows="3"
									></TextArea>
									<TextArea
										v-else
										:readonly="true"
										v-model="item['teacher_rating_explaination']"
										:label="'* ' + $t('texts.pleaseExplainRating')"
										rows="3"
									></TextArea>
								</v-col>
								<v-col cols="12" v-else class="pt-2 pb-8">
									<TextArea
										v-if="inEditMode"
										v-model="item['teacher_rating_explaination']"
										:label="$t('texts.pleaseExplainRating')"
										rows="3"
									></TextArea>
									<TextArea
										v-else
										:readonly="true"
										v-model="item['teacher_rating_explaination']"
										:label="$t('texts.pleaseExplainRating')"
										rows="3"
									></TextArea>
								</v-col>
							</v-card>
						</v-col>
					</v-row>
				</v-container>

				<v-col cols="12">
					<v-card flat class="pa-0 ma-0" color="shade">
						<v-col cols="12" class="pb-0">
							<div :class="['text-body-1', 'pt-2', 'pb-0']">
								{{ $t('texts.surveyQuestion1') }}
							</div>
						</v-col>
						<v-col cols="12" class="pt-0 pb-0">
							<v-radio-group v-model="candidateSurvey.office_rating" row mandatory hide-details="auto">
								<v-container class="d-flex justify-space-between pt-0">
									<v-radio label="1" :value="1" class="pl-4"></v-radio>
									<v-radio label="2" :value="2"></v-radio>
									<v-radio label="3" :value="3"></v-radio>
									<v-radio label="4" :value="4"></v-radio>
									<v-radio label="5" :value="5" class="pr-4"></v-radio>
								</v-container>
							</v-radio-group>
						</v-col>
						<v-col cols="12" v-if="candidateSurvey.office_rating <= 3" class="pt-2 pb-8">
							<TextArea
								:readonly="!inEditMode"
								v-model="candidateSurvey.office_rating_explaination"
								:errorBorder="!candidateSurveyValidation.office_rating_explaination"
								rows="3"
								:label="'* ' + $t('texts.pleaseExplainRating')"
							></TextArea>
						</v-col>
						<v-col cols="12" v-else class="pt-2 pb-8">
							<TextArea
								:readonly="!inEditMode"
								v-model="candidateSurvey.office_rating_explaination"
								:errorBorder="!candidateSurveyValidation.office_rating_explaination"
								rows="3"
								:label="$t('texts.pleaseExplainRating')"
							></TextArea>
						</v-col>
					</v-card>
				</v-col>

				<v-col cols="12">
					<v-card flat class="pa-0 ma-0" color="shade">
						<v-col cols="12" class="pb-0">
							<div :class="['text-body-1', 'pt-2']">
								{{ $t('texts.surveyQuestion2') }}
							</div>
						</v-col>
						<v-col cols="12" class="pt-0 pb-0">
							<v-radio-group v-model="candidateSurvey.course_rating" row mandatory hide-details="auto">
								<v-container class="d-flex justify-space-between pt-0">
									<v-radio label="1" :value="1" class="pl-4"></v-radio>
									<v-radio label="2" :value="2"></v-radio>
									<v-radio label="3" :value="3"></v-radio>
									<v-radio label="4" :value="4"></v-radio>
									<v-radio label="5" :value="5" class="pr-4"></v-radio>
								</v-container>
							</v-radio-group>
						</v-col>
						<v-col cols="12" v-if="candidateSurvey.course_rating <= 3" class="pt-2 pb-8">
							<TextArea
								:readonly="!inEditMode"
								v-model="candidateSurvey.course_rating_explaination"
								:errorBorder="!candidateSurveyValidation.course_rating_explaination"
								rows="3"
								:label="'* ' + $t('texts.pleaseExplainRating')"
							></TextArea>
						</v-col>
						<v-col cols="12" v-else class="pt-2 pb-8">
							<TextArea
								:readonly="!inEditMode"
								v-model="candidateSurvey.course_rating_explaination"
								:errorBorder="!candidateSurveyValidation.course_rating_explaination"
								rows="3"
								:label="$t('texts.pleaseExplainRating')"
							></TextArea>
						</v-col>
					</v-card>
				</v-col>

				<v-col cols="12">
					<v-card flat class="pa-0 ma-0" color="shade">
						<v-col cols="12" class="pt-6 pb-8">
							<TextArea
								:readonly="!inEditMode"
								v-model="candidateSurvey.remark"
								:errorBorder="!candidateSurveyValidation.remark"
								:label="'* ' + $t('fields.remarkPraise')"
								rows="3"
							></TextArea>
						</v-col>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12" class="d-flex justify-center">
				<v-btn v-if="inEditMode" class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import TextArea from '../../trinkets/TextArea';
import Survey from '../../../models/Survey';

export default {
	name: 'Survey',
	components: { TextArea },
	props: {
		inEditMode: Boolean,
		candidateSurveyId: [Number, String],
	},
	emits: ['close', 'reloadSurveyCandidates', 'reloadSurveyStats'],
	data() {
		return {
			candidateSurvey: new Survey({}),
			candidateSurveyValidation: new Survey({}, true),
			initialLoad: false,
			teachersValidation: [],
		};
	},
	watch: {
		inEditMode(newVal) {
			if (newVal) {
				this.getTeachers();
			}
		},
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getTeachers() {
			var vm = this;
			this.$APICall(
				'get',
				'planned-courses-teachers/' + this.$route.params.id,
				{},
				(data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.candidateSurvey.teachers = usableData;
						vm.teachersValidation = JSON.parse(JSON.stringify(data));
						for (const teacher of vm.teachersValidation) {
							teacher['teacher_id'] = true;
							teacher['full_name'] = true;
						}
						vm.initialLoad = true;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		getSurvey() {
			var vm = this;
			this.$APICall(
				'get',
				'planned-course-survey/' + this.candidateSurveyId,
				{},
				(data, success) => {
					if (success) {
						vm.candidateSurvey = data;
						vm.initialLoad = true;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			for (let i = 0; i < this.candidateSurvey.teachers.length; i++) {
				if (this.candidateSurvey.teachers[i].teacher_rating <= 3) {
					if (!this.candidateSurvey.teachers[i].hasOwnProperty('teacher_rating_explaination')) {
						this.teachersValidation[i].full_name = false;
						success = false;
					} else {
						if (this.candidateSurvey.teachers[i].teacher_rating_explaination.length > 750) {
							this.teachersValidation[i].full_name = false;
							success = false;

							errorMessages +=
								this.$t('alerts.lengthError')
									.replace('%field%', this.$t('texts.pleaseExplainRating'))
									.replace('%length%', '750') + '<br />';
						} else {
							this.teachersValidation[i].full_name = true;
						}
					}
				} else {
					this.teachersValidation[i].full_name = true;
				}
			}

			if (!this.candidateSurvey.course_rating) {
				success = false;
				this.candidateSurveyValidation.course_rating = false;
			} else {
				this.candidateSurveyValidation.course_rating = true;
			}

			if (!this.candidateSurvey.office_rating) {
				success = false;
				this.candidateSurveyValidation.office_rating = false;
			} else {
				this.candidateSurveyValidation.office_rating = true;
			}

			if (this.candidateSurvey.course_rating <= 3) {
				if (
					this.candidateSurvey.course_rating_explaination == null ||
					this.candidateSurvey.course_rating_explaination == ''
				) {
					success = false;
					this.candidateSurveyValidation.course_rating_explaination = false;
				} else {
					if (this.candidateSurvey.course_rating_explaination.length > 500) {
						this.candidateSurveyValidation.course_rating_explaination = false;
						errorMessages +=
							this.$t('alerts.lengthError')
								.replace('%field%', this.$t('texts.pleaseExplainRating'))
								.replace('%length%', '500') + '<br />';
					} else {
						this.candidateSurveyValidation.course_rating_explaination = true;
					}
				}
			} else {
				this.candidateSurveyValidation.course_rating_explaination = true;
			}

			if (this.candidateSurvey.office_rating <= 3) {
				if (
					this.candidateSurvey.office_rating_explaination == null ||
					this.candidateSurvey.office_rating_explaination == ''
				) {
					success = false;
					this.candidateSurveyValidation.office_rating_explaination = false;
				} else {
					if (this.candidateSurvey.office_rating_explaination.length > 500) {
						this.candidateSurveyValidation.office_rating_explaination = false;
						errorMessages +=
							this.$t('alerts.lengthError')
								.replace('%field%', this.$t('texts.pleaseExplainRating'))
								.replace('%length%', '500') + '<br />';
					} else {
						this.candidateSurveyValidation.office_rating_explaination = true;
					}
				}
			} else {
				this.candidateSurveyValidation.office_rating_explaination = true;
			}

			if (this.candidateSurvey.remark == null || this.candidateSurvey.remark == '') {
				success = false;
				this.candidateSurveyValidation.remark = false;
			} else {
				this.candidateSurveyValidation.remark = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				this.candidateSurvey.planned_course_id = this.$route.params.id;
				this.$APICall('post', 'surveys', this.candidateSurvey, (data, success) => {
					if (success) {
						vm.$notify(vm.$t('alerts.basicAdd'));
						vm.$modalBus.$emit('reloadSurveyCandidates');
						vm.$modalBus.$emit('reloadSurveyStats');
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
					this.$emit('close');
				});
			}
		},
	},
	mounted() {
		if (!this.inEditMode) {
			this.getSurvey();
		} else {
			this.getTeachers();
		}
	},
};
</script>
